import React, { useEffect, useState } from 'react';
import { Input as InputField } from 'antd';
import Dropdown from '../../components/common/dropdown';
import { CloseCircleOutlined } from '@ant-design/icons';

const HandleFaqComponent = ({ faqInputs, setFaqInputs, value, index }) => {
  const [faqData, setFaqData] = useState(value);
  const [inputQuestion, setInputQuestion] = useState(false);

  const dummyFaq = ['How is it helpful?', 'Other'];

  const handleQuestionChange = (e) => {
    if (e === 'Other') {
      setInputQuestion(true);
    } else {
      setInputQuestion(false);
      setFaqData({ ...faqData, question: e });
    }
  };

  const handleRemove = () => {
    let updatedFaqInputs = [];
    faqInputs?.forEach((inputs) => {
      if (inputs?.id !== faqData?.id) {
        updatedFaqInputs.push(inputs);
      }
    });
    setFaqInputs(updatedFaqInputs);
  };

  useEffect(() => {
    if (value?.question) setInputQuestion(!dummyFaq.includes(value?.question));
  }, [value]);

  useEffect(() => {
    const mappedFaqList = faqInputs?.map((input, i) => {
      return { ...input, id: i };
    });
    mappedFaqList.splice(index, 1, faqData);
    setFaqInputs(mappedFaqList);
  }, [faqData, index]);

  return (
    <div className="relative">
      <div className="sm:flex grid w-full sm:items-center gap-2 mt-2">
        <Dropdown
          data={dummyFaq}
          className="w-full hover:border-primaryBlue h-5.4"
          placeholder="Question"
          onChange={handleQuestionChange}
          defaultValue={
            inputQuestion && !dummyFaq.includes(value?.question)
              ? 'Other'
              : faqData?.question
              ? faqData?.question
              : null
          }
          isFAQ={true}
        />
        {inputQuestion && (
          <>
            <InputField
              onChange={(e) => {
                setFaqData({ ...faqData, question: e.target.value });
              }}
              className="w-full hover:border-primaryBlue h-5.4"
              placeholder="Question"
              value={faqData?.question}
            />
          </>
        )}
        <div className="relative w-full">
          <InputField
            value={faqData?.answer}
            onChange={(e) => {
              setFaqData({ ...faqData, answer: e.target.value });
            }}
            className="w-full hover:border-primaryBlue h-5.4"
            placeholder="Response"
          />
          {faqData.id !== 0 && (
            // Render close icon for non-first FAQ within the response input field
            <div className="absolute right-1 top-0 mt-1.5">
              <CloseCircleOutlined
                onClick={handleRemove}
                className="text-red-500 cursor-pointer"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HandleFaqComponent;
